/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskExclusionsList } from "../funcs/riskExclusionsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListRiskExclusionsResult } from "../models/components/listriskexclusionsresult.js";
import {
  ListRiskExclusionsRequest,
  ListRiskExclusionsSecurity,
} from "../models/operations/listriskexclusions.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskListExclusionsQueryData = ListRiskExclusionsResult;

export function prefetchRiskListExclusions(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRiskExclusionsRequest | undefined,
  security?: ListRiskExclusionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskListExclusionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskListExclusionsQuery(
  client$: GramCore,
  request?: ListRiskExclusionsRequest | undefined,
  security?: ListRiskExclusionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RiskListExclusionsQueryData>;
} {
  return {
    queryKey: queryKeyRiskListExclusions({
      riskPolicyId: request?.riskPolicyId,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function riskListExclusionsQueryFn(
      ctx,
    ): Promise<RiskListExclusionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskExclusionsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskListExclusions(
  parameters: {
    riskPolicyId?: string | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "exclusions", "list", parameters];
}
